import { OrderSetRow } from '@warebee/shared/export-converter';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useFormatter from '../common/useFormatter';
import { ColumnConfig } from '../components/DatasetTable';
import { getOrderSetSchema } from '../import/orders/schema/orderSetSchema';
import useOrderSetDataTableConfigBase from './useOrderSetDataTableConfigBase';

function useOrderSetDataTableConfig(): ColumnConfig<OrderSetRow>[] {
  const { t: tImporter } = useTranslation('importer');
  const { t } = useTranslation('dataset');
  const baseFieldsConfig = useOrderSetDataTableConfigBase();
  const formatter = useFormatter();
  const schema = _.keyBy(getOrderSetSchema(tImporter).fields, f => f.name);

  const columnsConfigRaw: ColumnConfig<OrderSetRow>[] = [
    ...baseFieldsConfig,
    {
      field: 'details.dailyStats.totalDaysWithOrders',
      title: t`Total Days with Orders`,
    },
    {
      field: 'details.weeklyStats.totalWeeksWithOrders',
      title: t`Total Weeks with Orders`,
    },
    {
      field: 'details.dailyStats.orderLineCount.avg',
      title: t`Daily Order Lines (Avg)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'details.dailyStats.orderLineCount.max',
      title: t`Daily Order Lines (Max)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'details.dailyStats.orderLineCount.cv',
      title: t`Daily Orders CV`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'details.weeklyStats.orderLineCount.avg',
      title: t`Weekly Order Lines (Avg)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'details.weeklyStats.orderLineCount.max',
      title: t`Weekly Order Lines (Max)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'details.weeklyStats.daysWithOrders.avg',
      title: t`Weekly Days with Orders (Avg)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'details.weeklyStats.daysWithOrders.max',
      title: t`Weekly Days with Orders (Max)`,
      render: (v: number) => formatter.formatNumber(v, 1).fullString,
    },
    {
      field: 'details.weeklyStats.daysWithOrders.cv',
      title: t`Weekly Days with Orders CV`,
      render: (v: number) => formatter.formatNumber(v, 2).fullString,
    },
  ];

  const columnsConfig = columnsConfigRaw.map(f => ({
    ...f,
    title: f.title ?? schema[f.field]?.title,
  }));

  return columnsConfig;
}
export default useOrderSetDataTableConfig;
